<div class="toolbox">
  <!-- left -->
  <div class="toolbox-l">
    <ng-container *ngIf="toolboxLeftTpl != null">
      <ng-container
        *ngTemplateOutlet="toolboxLeftTpl; context: { dataSource: dataSource, selection: selection }"
      ></ng-container>
    </ng-container>
  </div>

  <!-- right -->
  <div class="toolbox-r">
    <ng-container *ngIf="toolboxRightTpl != null">
      <ng-container
        *ngTemplateOutlet="toolboxRightTpl; context: { dataSource: dataSource, selection: selection }"
      ></ng-container>
    </ng-container>
  </div>
</div>
<div class="table-container cbre-table-container">
  <!-- toolbox -->

  <!-- TABLE -->
  <mat-table
    id="{{ tableId }}Table"
    [dataSource]="dataSource"
    matSort
    class="cbre-table"
    [ngStyle]="{ 'max-height': maxHeight }"
    [ngClass]="{ 'cbre-table--empty': dataSource?.data?.length === 0 }"
  >
    <!-- TABLE SELECTION -->
    <ng-container *ngIf="selectionMode != null">
      <ng-container [matColumnDef]="SELECT_CELL_COLUMN_DEF" sticky>
        <!-- SELECT ALL CHECKBOX -->
        <th mat-header-cell *matHeaderCellDef scope="col" [ngClass]="column?.headerClass || ''">
          <mat-checkbox
            id="{{ tableId }}Table_chkSelectAll"
            *ngIf="selectionMode === 'multi' && elements.length"
            [checked]="isAllSelected"
            [indeterminate]="isIndeterminate"
            [aria-label]="checkboxLabel()"
            (change)="$event ? selectAllToggle() : null"
          >
          </mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let row" [ngClass]="column?.headerClass || ''">
          <ng-container *ngIf="selectionMode === 'multi'">
            <mat-checkbox
              id="{{ tableId }}Table_chkSelectRow"
              [checked]="selection?.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
              (click)="$event.stopPropagation()"
              (change)="$event ? selectionToggle(row) : null"
            >
            </mat-checkbox>
          </ng-container>
          <ng-container *ngIf="selectionMode === 'single'">
            <mat-radio-button
              id="{{ tableId }}Table_radioSelectRow"
              [checked]="selection?.isSelected(row)"
              [aria-label]="checkboxLabel(row)"
              (click)="$event.stopPropagation()"
              (change)="$event ? selectionToggle(row) : null"
            >
            </mat-radio-button>
          </ng-container>
          <!-- SELECT EACH ROW CHECKBOX -->
        </td>
      </ng-container>
    </ng-container>

    <!-- ACTIONS CELL DEFINITION -->
    <ng-container *ngIf="cellEventsTpl != null">
      <ng-container [matColumnDef]="EVENT_CELL_COLUMN_DEF">
        <th mat-header-cell *matHeaderCellDef scope="col">
          <ng-container *ngIf="headerEventsTpl != null">
            <ng-container
              *ngTemplateOutlet="headerEventsTpl; context: { row: row, selection: selection }"
            ></ng-container>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngTemplateOutlet="cellEventsTpl; context: { row: row, selection: selection }"></ng-container>
        </td>
      </ng-container>
    </ng-container>

    <!-- EACH COLUMN DEF -->
    <ng-container *ngFor="let column of columns; trackBy: trackColumn">
      <!-- COLUMN TEMPLATES -->
      <ng-container [matColumnDef]="column.path ?? column.field" [sticky]="!!column.sticky">
        <!-- TH HEADER -->
        <th
          mat-header-cell
          *matHeaderCellDef
          scope="col"
          mat-sort-header
          [disabled]="!column.sortable"
          [ngClass]="column?.headerClass || ''"
          id="{{ tableId }}Table_headerColumn{{ column.columnId }}"
        >
          {{ column.header }} <span *ngIf="column.required" class="required-icon"> * </span>
          <div *ngIf="column.tooltip" class="controls-table-column-tooltip">
            <mat-icon [matTooltip]="column.tooltip" matTooltipPosition="above" svgIcon="unknown"></mat-icon>
          </div>
        </th>

        <!-- TD DEF -->
        <td mat-cell *matCellDef="let row" id="{{ tableId }}Table_column{{ column.columnId }}">
          <!-- if CellRenderer is configured render it else use given template or default template -->
          <ng-container *ngIf="column.CellRenderer != null; else useConfiguredTplOrDefaultTpl">
            <cbre-cell-renderer [data]="row" [config]="column"></cbre-cell-renderer>
          </ng-container>

          <ng-template #useConfiguredTplOrDefaultTpl>
            <!-- USE GIVEN TEMPLATE OR DEFAULT -->
            <ng-container *ngIf="cellRendererTpl != null; else defaultCellRenderer">
              <!-- RENDER GIVEN TEMPLATE COL DEF -->
              <ng-container
                *ngTemplateOutlet="cellRendererTpl; context: { row: row, column: column, selection: selection }"
              ></ng-container>
            </ng-container>

            <ng-template #defaultCellRenderer>
              <span [matTooltip]="row | rowColumnTooltip: column" matTooltipPosition="right">
                {{ row[column.path || column.field] }}
              </span>
            </ng-template>
          </ng-template>
        </td>
      </ng-container>
    </ng-container>

    <!-- ROW TEMPLATES -->

    <!-- HEADER TPL -->
    <tr
      mat-header-row
      *matHeaderRowDef="
        columns
          | toDisplayedColumns: { isCellEventsPresent: !!cellEventsTpl, isSelectionModeOn: selectionMode != null };
        sticky: stickyHeader
      "
    ></tr>

    <!-- ROW DATA TPL -->
    <tr
      mat-row
      id="{{ tableId }}Table_row{{ row.id }}"
      *matRowDef="
        let row;
        columns: columns
          | toDisplayedColumns: { isCellEventsPresent: !!cellEventsTpl, isSelectionModeOn: selectionMode != null }
      "
      [ngClass]="{
        disabled: row | isRowDisabled: selectionHandler?.isSelectionDisabled,
        'mat-mdc-row--clickable': isRowClickable,
      }"
      [matTooltip]="
        (row | isRowDisabled: selectionHandler?.isSelectionDisabled) ? selectionHandler?.disableRowTooltip : ''
      "
      [class]="row.rowClass"
      (click)="handleRowClick(row)"
    ></tr>

    <!-- NO DATA TPL -->
    <tr class="mat-row cbre-table--no-data-row" *matNoDataRow>
      <td
        [attr.colspan]="
          columns.length + (selectionMode != null || headerEventsTpl != null || cellEventsTpl != null ? 1 : 0)
        "
      >
        {{ noDataLabel }}
      </td>
    </tr>

    <!-- Row shown when there is no matching data. -->
  </mat-table>
</div>
<ng-container *ngIf="(elements.length > 10 || totalCount > 10) && !hidePaginator">
  <mat-paginator
    class="cbre-paginator"
    #controlTablePaginator
    [length]="totalCount ?? elements.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [selectConfig]="paginatorSelectConfig"
    (page)="pageChange.emit($event)"
    [showFirstLastButtons]="showFirstLastButtons"
  ></mat-paginator>
</ng-container>
